export default __webpack_public_path__ + "static/char-62-b22e7a0f93dbd4c7cdd0c0c282e1b317.gif";